import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleTeaser from './components/ArticleTeaser';
import BenefitsSection from './components/BenefitsSection';
import ComparisonTable from './components/ComparisonTable';
import SafetySection from './components/SafetySection';
import BlogGrid from './components/BlogGrid';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.quest';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spread',
  url: siteUrl,
  description: 'Il punto di riferimento italiano per Itaobuy Spreadsheet: guide, prodotti selezionati e risorse aggiornate per lo shopping internazionale.',
  inLanguage: 'it',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Itaobuy Spread',
  url: siteUrl,
  sameAs: ['https://kaspreadsheet.com'],
  description: 'Risorsa italiana per guide e prodotti Itaobuy Spreadsheet.',
  knowsAbout: [
    'Itaobuy Spreadsheet',
    'Shopping internazionale',
    'Prodotti cinesi',
    'Sneakers',
    'Streetwear',
    'Fashion',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd schema={websiteSchema} />
      <JsonLd schema={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleTeaser />
        <BenefitsSection />
        <ComparisonTable />
        <SafetySection />
        <BlogGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}